"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
const events_1 = __importDefault(require("events"));
const typings = __importStar(require("@monorepo/typings/sdk"));
const utils_1 = require("../../shared/utils");
class Api extends events_1.default {
    sdk;
    active = new Map();
    uuid;
    connected;
    target;
    timestamp;
    constructor(sdk) {
        super();
        this.sdk = sdk;
        this.uuid = (0, utils_1.uuid)();
        this.connected = false;
        this.timestamp = Date.now();
        if (typeof window !== 'undefined') {
            this.target = window.origin;
            window.addEventListener('message', this.#handleMsg);
        }
    }
    #handleMsg = (event) => {
        try {
            if (!window)
                return;
            if (window &&
                (event.source !== window || !event.source || event.origin !== window.location.origin))
                return;
            if (!event.data)
                return;
            let type = event.data?.type || undefined;
            let resp = event.data?.response || undefined;
            let app = event.data?.app || undefined;
            if (type === 'request' && app !== this.sdk.app)
                return;
            if (type === typings.TYPES.UPDATE)
                return;
            if (type === typings.TYPES.EVENT && 'type' in event.data)
                return this.#handleEvent(event.data);
            if (resp && resp.type === typings.TYPES.RESPONSE)
                this.emit(typings.EVENTS.RESPONSE, event.data);
            if (resp && resp.type === typings.EVENTS.RESPONSE && this.active.get(resp.id)) {
                return this.active.get(resp.id)?.resolve(event.data);
            }
        }
        catch (e) {
            return;
        }
    };
    #handleEvent = (e) => {
        if (e.event === typings.EVENTS.PING)
            this.emit(typings.EVENTS.PING);
        if (e.event === typings.EVENTS.CLOSE)
            this.emit(typings.EVENTS.CLOSE);
        if (e.event === typings.EVENTS.OPEN)
            this.emit(typings.EVENTS.OPEN);
        if (e.event === typings.EVENTS.SIGNOUT)
            this.emit(typings.EVENTS.SIGNOUT);
        if (e.event === typings.EVENTS.USER_CHANGE)
            this.emit(typings.EVENTS.USER_CHANGE, e.data);
        if (e.event === typings.EVENTS.NETWORK_CHANGE)
            this.emit(typings.EVENTS.NETWORK_CHANGE, e.data);
    };
    #fire = async (request) => {
        let response = await new Promise((resolve, reject) => {
            this.active.set(request.id, {
                resolve: resolve,
                reject: reject,
            });
            if (window)
                window.postMessage(request);
        });
        this.active.delete(request.id);
        return response;
    };
    awaitRequest = async (request) => {
        try {
            let res = await this.#fire({
                app: this.sdk.app,
                type: typings.TYPES.REQUEST,
                id: (0, utils_1.uuid)(),
                ...request,
            });
            return res;
        }
        catch (e) {
            throw e;
        }
    };
    request = (request) => {
        try {
            let id = (0, utils_1.uuid)();
            this.#fire({
                app: this.sdk.app,
                type: typings.TYPES.REQUEST,
                id,
                ...request,
            });
            return id;
        }
        catch (e) {
            throw e;
        }
    };
}
exports.Api = Api;
